import { createActionGroup, emptyProps, props } from '@ngrx/store'
import { Job } from '../../shared/model/jobs'
import { HttpErrorResponse } from '@angular/common/http'

export const jobActions = createActionGroup({
    source: 'Job',
    events: {
        'Loading Jobs Succeeded': props<{ jobs: Job[]; updatedJobs: Job[] }>(),
        'Loading Jobs Failed': props<{ error: HttpErrorResponse; message: string }>(),
        'Reload Jobs': emptyProps(),
        'Stop Polling': emptyProps(),
    },
})
